import React from 'react';
import {AgGridColumn} from "../../components/agGridColumn";
import Grid from '../../components/grid';
import { ActionProps } from '../../components/gridAction';

const WebhookMattermostList = () => {

    const actions: Array<ActionProps> = [
        {
            route: 'mattermost/webhook/incluir',
            color: 'primary',
            type: 'normal',
            title: 'Incluir',
        },
        {
            route: 'mattermost/webhook/visualizar',
            color: 'info',
            type: 'grid',
            title: 'Visualizar',
        },
        {
            route: 'mattermost/webhook/alterar',
            color: 'warning',
            type: 'grid',
            title: 'Editar',
        },
    ];

    const defaultColumnDefinition = {
        resizable: true,
        flex: 1,
        filter: true,
        sortable: true,
    };

    return (
        <Grid actions={actions} rota="mattermost/webhook/list" defaultColDef={defaultColumnDefinition}>
            <AgGridColumn headerName="#"           field="id"         maxWidth={100} />
            <AgGridColumn headerName="Canal"       field="canalNome"  minWidth={200} />
            <AgGridColumn headerName="Nome do Bot" field="username"   minWidth={200} />
            <AgGridColumn headerName="ID Webhook"  field="idWebhook"  minWidth={250} />
        </Grid>
    );
};

export default WebhookMattermostList;
